import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["radio", "licenseOption"]

  connect() {
    this.update()
  }

  update() {
    const selectedRadio = this.radioTargets.find(radio => radio.checked)
    if (!selectedRadio) return

    const isRestricted = selectedRadio.value === 'restricted'

    if (this.hasLicenseOptionTarget) {
      if (isRestricted) {
        this.licenseOptionTarget.classList.remove('hidden')
      } else {
        this.licenseOptionTarget.classList.add('hidden')
      }
    }
  }
}
